var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.hasVat
        ? [
            _c("app-pay-row", { attrs: { label: _vm.$ct("price-with-vat") } }, [
              _vm._v(
                " € " +
                  _vm._s(_vm._f("printHumanFloat")(_vm.priceWithVat)) +
                  " "
              ),
            ]),
          ]
        : _vm._e(),
      _c("app-pay-row", { attrs: { label: _vm.$ct("labels.interval") } }, [
        _vm._v(" " + _vm._s(_vm.interval) + " "),
      ]),
      !_vm.hidePeriod
        ? _c("app-pay-row", { attrs: { sub: "" } }, [
            _vm._v(
              " " +
                _vm._s(_vm._f("printLocalDate")(_vm.fromDate)) +
                " - " +
                _vm._s(_vm._f("printLocalDate")(_vm.tillDate)) +
                " "
            ),
          ])
        : _vm._e(),
      _c("app-pay-row"),
      _c("app-pay-row", { attrs: { label: _vm.$ct("labels.total") } }, [
        _vm._v(" € " + _vm._s(_vm._f("printHumanFloat")(_vm.price)) + " "),
      ]),
      _c("app-pay-row", { attrs: { sub: "" } }, [
        _vm._v(
          " € " +
            _vm._s(_vm._f("printHumanFloat")(_vm.pricePerMonth)) +
            " / " +
            _vm._s(_vm.$ct("pricing.short-per-month")) +
            " "
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }